import { Link } from 'react-router-dom';
import { guides } from '@/mocks/articles';

export default function ArticlesSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            Przewodniki
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Powiązane przewodniki i artykuły
          </h2>
          <p className="text-foreground-600 max-w-[600px] mx-auto leading-relaxed">
            Pogłębiaj swoją wiedzę o USFansSpreadsheet dzięki naszym szczegółowym przewodnikom, 
            recenzjom i porównaniom.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {guides.map((guide) => (
            <div
              key={guide.slug}
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:shadow-sm transition-all duration-300 overflow-hidden"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={guide.image}
                  alt={guide.title}
                  title={guide.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex flex-col p-5 md:p-6 flex-1">
                <div className="flex items-center gap-3 mb-3">
                  <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300 flex-shrink-0">
                    <i className={guide.icon}></i>
                  </span>
                  <h3 className="font-heading text-base font-semibold text-foreground-950 leading-snug">
                    {guide.title}
                  </h3>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 flex-1">
                  {guide.description}
                </p>
                <Link
                  to={`/artykul/${guide.slug}`}
                  className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer mt-auto"
                >
                  Czytaj więcej
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}